import React from 'react';
import $ from 'jquery';
import styles from '../signature_pad/styles.css'
import SignaturePad from 'react-signature-canvas'
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';

import {
    Button,
    Alert,

} from 'react-bootstrap';

export default class SignaturePadRedirect extends React.Component {
  sigPad = {}

  constructor(props){
    super(props);
    this.state = {
      trimmedDataURL: null, 
      redirect: false, 
      redirect_url:'', 
      sigpad_empty_warning:[],
      buttons_disabled: false,
    };
  }

  componentDidMount = () => {
      // console.log('SignaturePadRedirect this.props.redirect_url');
      // console.log(this.props.redirect_url);
  }

  clear = () => {
    this.sigPad.clear()
  }

  getCookie = (c_name) => {
      if(document.cookie.length > 0) {
          let c_start = document.cookie.indexOf(c_name + "=");
          if(c_start != -1) {
              c_start = c_start + c_name.length + 1;
              let c_end = document.cookie.indexOf(";", c_start);
              if(c_end == -1) c_end = document.cookie.length;
              return unescape(document.cookie.substring(c_start,c_end));
          }
      } else {
          return "";
      }
  }

  submitSignature = () => {
      this.setState({buttons_disabled: true})
      // console.log('Is the sigpad empty?')
      // console.log(this.sigPad.isEmpty())
      if (this.sigPad.isEmpty() == true) {
          let sigpad_empty_warning = [];
          sigpad_empty_warning.push(
            <Alert bsStyle='danger' style={{maxWidth: '300px'}}>
                <p>
                    <i className='fa fa-exclamation-triangle' /> A signature is required!
                </p>
            </Alert>
          )
          this.setState({sigpad_empty_warning});
      } else {
        let field = this.props.field;
        let url = this.props.url;
        let cookie = this.getCookie('csrftoken');
        let data = {};
        data[field] = this.sigPad.getTrimmedCanvas().toDataURL('image/png');
        $.ajax({
            url: url,
            dataType: 'json',
            method: 'PUT',
            headers: {"X-CSRFToken": cookie},
            data: data,
            cache: false,
            success: (data) => {
              this.setState({redirect: true})
              this.props.clearEditingInstance();
              this.props.setMessage(this.props.message, 'success');
            },
            error: (xhr, status, err) => {}
        });
      }
  }

  render () {
    // console.log('render SignaturePadRedirect ')
    if (this.state.redirect === true) {
        // console.log('this.state.redirect is True!!!')
        return <Redirect to={this.props.redirect_url} />;
    }

    let trimmedDataURL = this.state.trimmedDataURL;

    return (
        <div>
          <div>
          <Alert bsStyle='success' style={{maxWidth: '300px'}}>
                <p>
                    <i className='fa fa-info-circle'></i> Sign your first and last name and upon submitting PLEASE ALLOW UP TO 3 SECONDS for the system to process your signature.
                </p>
            </Alert>
          </div>
          <div style={{'marginBottom': '10px'}}>
              <div style={{'width': '300px', 'height': '325px', 'border': '1px solid black'}}>
                  <SignaturePad
                      canvasProps={{width: 300,height: 325, className: 'sigCanvas'}}
                      ref={(ref) => { this.sigPad = ref }}
                  />
              </div>
          </div>
          <div>{this.state.sigpad_empty_warning}</div>
          <div>
            <Button className={styles.buttons} onClick={this.clear} disabled={this.state.buttons_disabled}>
              Clear
            </Button>
            <Button className={styles.buttons} bsStyle='success' onClick={this.submitSignature} style={{marginLeft:5}} disabled={this.state.buttons_disabled}>
              Submit
            </Button>
            <Button className={styles.buttons} style={{'marginLeft': '5px'}} onClick={() => this.setState({redirect:true})} disabled={this.state.buttons_disabled}>
              Cancel
            </Button>
          </div>
        </div>
    )
  }
}

SignaturePadRedirect.propTypes = {
    redirect_url: PropTypes.node,
    message: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/helpers/field/signature_pad_redirect.js